import * as React from "react";
import { TrendingUp, MousePointerClick, Palette, Smartphone, Zap, Puzzle, Check } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const benefits = [{
  title: "Inteligencia de Datos",
  icon: TrendingUp,
  items: ["Seguimiento de comportamiento 3D", "Mapas de calor de interacción", "Analítica de conversión espacial"]
}, {
  title: "Optimización UX/UI",
  icon: MousePointerClick,
  items: ["Interfaces de usuario intuitivas", "Navegación inmersiva fluida", "Reducción de fricción en ventas"]
}, {
  title: "Fidelidad Visual",
  icon: Palette,
  items: ["Renderizado Unreal Engine 5", "Iluminación global realista", "Texturas 4K de alta precisión"]
}, {
  title: "Omnicanalidad Total",
  icon: Smartphone,
  items: ["Compatible con cascos VR", "Experiencia móvil optimizada", "Kioscos táctiles interactivos"]
}, {
  title: "Rendimiento Cloud",
  icon: Zap,
  items: ["Streaming 3D de baja latencia", "Carga instantánea de activos", "Infraestructura global escalable"]
}, {
  title: "Ecosistema Partner",
  icon: Puzzle,
  items: ["Integración nativa con CRM", "API para portales inmobiliarios", "Sincronización de inventario"]
}];
export default function ProductBenefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="33553" id="collaborative-ecosystem" className="bg-background py-32 relative overflow-hidden text-foreground">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-[-20%] left-[20%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-20%] right-[20%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={cn("text-center mb-20 transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-[42px] font-default font-bold mb-6 tracking-tight">
            <span className="bg-gradient-to-r from-primary via-primary/80 to-primary/60 bg-clip-text text-transparent">
              Ecosistema de Inteligencia Espacial
            </span>
          </h2>
          <p className="text-muted-foreground font-default text-lg max-w-2xl mx-auto">
            PropVR.ai se integra perfectamente con las herramientas líderes de la industria para transformar la comercialización de proyectos inmobiliarios.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => <div key={index} data-index={index} className={cn("transition-all duration-700 ease-out delay-[var(--delay)]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
          "--delay": `${index * 100}ms`
        } as React.CSSProperties}>
              <Card className="h-full bg-card border border-border rounded-[12px] group hover:scale-[1.02] hover:shadow-xl hover:shadow-primary/10 transition-all duration-300 overflow-hidden">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex items-center justify-center w-14 h-14 rounded-xl bg-secondary group-hover:bg-primary/10 transition-colors duration-300">
                    <benefit.icon className="w-7 h-7 text-primary drop-shadow-[0_0_8px_rgba(23,85,253,0.3)]" />
                  </div>
                  <CardTitle className="text-xl font-default font-bold text-foreground group-hover:text-primary transition-colors">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {benefit.items.map((item, i) => <li key={i} className="flex items-start gap-3 text-muted-foreground group-hover:text-foreground transition-colors">
                        <Check className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                        <span className="text-sm font-default leading-relaxed">{item}</span>
                      </li>)}
                  </ul>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}